"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _highcharts = require("highcharts/highcharts");

var _highcharts2 = _interopRequireDefault(_highcharts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnquiriesBreakdownController = function () {
  function EnquiriesBreakdownController($scope) {
    "ngInject";

    //Begin Services

    var _this = this;

    (0, _classCallCheck3.default)(this, EnquiriesBreakdownController);
    this.$scope = $scope;
    //End Services

    //Begin Data
    this.hasNoTarget = false;
    this.chartContainerId = "chartContainer" + this.getGuid();
    this.chart = null;
    //End Data

    //Begin Initialize
    this.$onChanges = function (changesObj) {
      if (changesObj.data && changesObj.data.currentValue) {
        _this.chart = _this.generateChart();
      }
    };
    //End Initialize 
  }

  (0, _createClass3.default)(EnquiriesBreakdownController, [{
    key: "generateChart",
    value: function generateChart() {
      var _chartOptions;

      //Chart Code Start    
      var ctrl = this;

      var series = this.data.map(function (item) {
        var identifiers = {};

        if (ctrl.identifiers) {
          ctrl.identifiers.map(function (id) {
            identifiers[id] = item[id];
          });
        }

        return {
          name: item.name,
          y: item.count,
          identifiers: identifiers
        };
      });

      var chartOptions = (_chartOptions = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie',
          height: '300'
        },
        title: null,
        tooltip: {
          pointFormat: '<b>{point.percentage:.1f}%</b>'
        },
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: ctrl.event !== undefined,
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true,
            point: {
              events: {
                legendItemClick: function legendItemClick(e) {
                  this.select();
                  this.events.click(this.identifiers);
                  e.preventDefault();
                }
              }
            }
          }
        },
        legend: {
          align: 'right',
          verticalAlign: 'top',
          layout: 'vertical',
          x: 0,
          y: 10,
          labelFormat: '{name} ({y})'
        },
        credits: {
          enabled: false
        }
      }, (0, _defineProperty3.default)(_chartOptions, "title", {
        align: 'center',
        //text: ctrl.chartTitle,
        text: null,
        verticalAlign: 'bottom',
        y: 10
      }), (0, _defineProperty3.default)(_chartOptions, "series", [{
        name: 'Brands',
        colorByPoint: true,
        data: series,
        point: {
          events: {
            click: function click(identifiers) {
              if (ctrl.event) {
                ctrl.$scope.$emit('leadMonitor:selectionChanged', {
                  event: ctrl.event,
                  name: this.name,
                  identifiers: this.identifiers || identifiers
                });
              }
            }
          }
        }
      }]), _chartOptions);

      // The speed gauge
      return _highcharts2.default.chart(this.chartContainerId, chartOptions);

      //Chart Code End
    }
  }, {
    key: "getGuid",
    value: function getGuid() {
      return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    }
  }]);
  return EnquiriesBreakdownController;
}();

exports.default = EnquiriesBreakdownController;


// WEBPACK FOOTER //
// ./client/app/components/leadMonitor/enquiriesBreakdown/enquiriesBreakdown.controller.js